import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import styles from "./list.module.css";
import { TextField, Button, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, TableFooter } from "@mui/material";
import { StyledMainTableCell, StyledMainTableRow } from "../../../components/TableComponent";
import TablePaginationComponent from "../../../components/TablePagination";
import { Close } from "@mui/icons-material";
import axios from "axios";
import Loader from "../../../components/Loader";
import { TableLoader } from "../../../components/ContentLoader";
import { authData, withAdminAuth } from "../../../components/GetAuth";
import { Home, Search } from "react-feather";

const EnquiryList = () => {
  const auth = authData();
  const API_TOKEN = auth?.api_token;
  const bookingId = useParams();
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterVars, setFilterVars] = useState({ searchKey: "", status: "", date: null });

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchBookings = () => {
      setContentLoading(true);
      axios.get(process.env.REACT_APP_API_URL + "v1/bookings-enquery/" + bookingId?.bookingId, {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    };

    fetchBookings();
  }, [API_TOKEN, bookingId?.bookingId]);

  useEffect(() => {
    let filterredTempData = allData;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredTempData = filterredTempData.filter((item) => {
        return (item.item_id.toLowerCase().includes(inputVal) || item.product_title.toLowerCase().includes(inputVal));
      });
    }

    setFilteredData(filterredTempData);
  }, [allData, filterVars]);

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>
      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
          <p className={`${styles.PageTitle}`}>Enquiry List</p>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Booking</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>Enquiry List</li>
            </ol>
          </nav>
        </div>)}

        {!contentLoading && (<>
          <div className="TableFilterHead">
            <div className="DataTableSearch">
              <Search className="SearchIcon" />
              <TextField type="text" placeholder="Search" value={filterVars?.searchKey} onChange={(e) => setFilterVars((prev) => { return { ...prev, searchKey: e.target.value }; })} />
              {filterVars?.searchKey !== "" && (<Button type="button" className="CloseBU" onClick={(e) => setFilterVars((prev) => { return { ...prev, searchKey: "" }; })}><Close /></Button>)}
            </div>
          </div>

          <div className="CusTable">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell>Booking Id</StyledMainTableCell>
                    <StyledMainTableCell>Item Id</StyledMainTableCell>
                    <StyledMainTableCell>Items</StyledMainTableCell>
                    <StyledMainTableCell>Paid</StyledMainTableCell>
                    <StyledMainTableCell>Status</StyledMainTableCell>
                    <StyledMainTableCell>Pick Driver</StyledMainTableCell>
                    <StyledMainTableCell>Delivery Driver</StyledMainTableCell>
                    <StyledMainTableCell>Recepient Name</StyledMainTableCell>
                    <StyledMainTableCell>Recepient Address</StyledMainTableCell>
                    <StyledMainTableCell>Recepient Mobile</StyledMainTableCell>
                    <StyledMainTableCell>Container</StyledMainTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item) => {
                    return (<>
                      <StyledMainTableRow sx={{ "& > *": { borderBottom: "unset" } }}>
                        <TableCell>{item?.booking_status?.booking_id}</TableCell>
                        <TableCell component="th" scope="row">{item?.item_id}</TableCell>
                        <TableCell component="th" scope="row">{item?.product_title}</TableCell>
                        <TableCell component="th" scope="row">£{parseFloat(item?.booking_status?.paid_amount).toFixed(2)}</TableCell>
                        <TableCell component="th" scope="row">{item?.status_text}</TableCell>
                        <TableCell component="th" scope="row">{item?.driver ? item?.driver?.name : "---"}</TableCell>
                        <TableCell component="th" scope="row">---</TableCell>
                        <TableCell component="th" scope="row">{item?.recepient_data?.name}</TableCell>
                        <TableCell component="th" scope="row">{item?.recepient_data?.address}</TableCell>
                        <TableCell component="th" scope="row">{item?.recepient_data?.phone}</TableCell>
                        <TableCell component="th" scope="row"> - </TableCell>
                      </StyledMainTableRow>
                    </>);
                  })}

                  {filteredData.length === 0 && (<TableRow>
                    <TableCell colSpan={10} align="center">No data found</TableCell>
                  </TableRow>)}
                </TableBody>

                {filteredData?.length > 0 && (<TableFooter>
                  <TableRow>
                    <TablePaginationComponent
                      count={filteredData?.length}
                      colSpan={6}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={paginationChangePage}
                      handleChangeRowsPerPage={
                        paginationChangeRowsPerPage
                      }
                    />
                  </TableRow>
                </TableFooter>
                )}
              </Table>
            </TableContainer>
          </div>
        </>)}
      </div>
    </div>
  </>);
};

export default withAdminAuth(EnquiryList);